function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STATE_DEFAULT = {};
export var PLOT_RADIO_UPDATE = 'PLOT_RADIO_UPDATE';
export default function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case PLOT_RADIO_UPDATE:
      return Object.assign({}, state, _defineProperty({}, action.plotId, action.radioId));

    default:
      return state;
  }
}